import { Divider } from '@mui/material'
import { useAppDispatch } from 'app/state'
import { isPendingOrRunning } from 'features/jobs/models/jobs'
import { setJobsPopperState } from 'features/jobs/state/jobsProcessingSlice'

import JobProcessingItem from '../JobItem/JobProcessingItem/JobProcessingItem'
import useProcessingJobs from '../useJobs/useProcessingJobs'
import JobsTabsItem from './JobsTabsItem'

function JobsProcessingTab() {
  const dispatch = useAppDispatch()

  const { processingJobs, processingJobsNotCleared, clearJobs, areAnyProcessingJobsRunning } = useProcessingJobs()
  const hasJobs = processingJobsNotCleared.length > 0

  const areAllProccessingJobsRunning = processingJobs.every(isPendingOrRunning)

  const handleClose = () => {
    dispatch(setJobsPopperState({ open: false }))
  }

  return (
    <>
      <JobsTabsItem
        hasJobs={hasJobs}
        areJobsRunning={areAnyProcessingJobsRunning}
        areAllJobsRunning={areAllProccessingJobsRunning}
        clearJobs={clearJobs}
      >
        <>
          {processingJobsNotCleared.map((job, i) => (
            <div key={job.jobId}>
              <JobProcessingItem job={job} onClose={handleClose} />
              {i !== processingJobsNotCleared.length - 1 && <Divider />}
            </div>
          ))}
        </>
      </JobsTabsItem>
    </>
  )
}

export default JobsProcessingTab
